<template>
  <el-card class="login-form">
    <el-form :model="loginForm">
      <el-form-item :label="language('login.username')" prop="username">
        <el-input v-model="loginForm.username" :width="100" maxlength="15"></el-input>
      </el-form-item>
      <el-form-item :label="language('login.password')" prop="password">
        <el-input type="password" v-model="loginForm.password" :width="100" maxlength="15"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="doLogin()">{{language('login.login')}}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loginForm: {
        username: "zhaoliu",
        password: "123456"
      }
    };
  },
  methods: {
    doLogin() {
      this.ccRequest
        .do(this.$apis.apiList.sys.admin_login, this.loginForm)
        .then(res => {})
        .catch(err => {});
    }
  },
  mounted() {},
  created() {}
};
</script>

<style>
.login-form {
  width: 400px;
  height: 300px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -150px;
  margin-left: -200px;
}
</style>
